define("shared/components/shared/guidelines", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/object", "@ember/service", "@glimmer/component", "ember-concurrency", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _object, _service, _component2, _emberConcurrency, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"ember-concurrency",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
  function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <Shared::Modal @close={{unless @closeGuidelines (perform this.closeGuidelines) @closeGuidelines}} as |modal|>
    <modal.card @portrait={{true}} data-test-id="guidelines-modal">
      <modal.card-header>
        <h3 class="o--modalHeader__title {{@titleQaClass}}">
          {{@title}}
        </h3>
      </modal.card-header>
      <modal.card-body class="u--p__t__0">
        <p class={{@subtitleQaClass}}>
          {{html-safe @subtitle}}
        </p>
        <hr class={{@dividerClass}} />
        {{#if (has-block)}}
          {{yield}}
        {{/if}}
        <div>
          {{#each @checkboxList as |checkbox|}}
            <div class="o--form__checkbox u--p__b__xs">
              <label class={{if checkbox.qaLabel checkbox.qaLabel}}>
                <Input
                  @checked={{checkbox.isChecked}}
                  @type="checkbox"
                  class="regram_tos {{if checkbox.qaCheckbox checkbox.qaCheckbox}}"
                  data-test-id={{checkbox.id}}
                />
                {{html-safe (t checkbox.label)}}
                {{#if checkbox.link}}
                  <Shared::Link
                    @href={{checkbox.link.href}}
                    @text={{checkbox.link.text}}
                    {{on "click" (action checkbox.link.onClick)}}
                  />
                {{/if}}
              </label>
            </div>
          {{/each}}
        </div>
        <p class={{@disclaimerQaClass}}>
          {{html-safe @disclaimer}}
        </p>
      </modal.card-body>
      <modal.card-footer>
        <Shared::Ui::Button
          @isDisabled={{not this.canAgree}}
          @onClick={{this.agree}}
          @text={{this.agreeButtonText}}
          class="{{if @noDeclineButton 'o--btn--block' 'u--float--right'}} {{@agreeQaClass}}"
          data-test-id="guidelines-agree-button"
        />
        {{#unless @noDeclineButton}}
          <Shared::Ui::Button
            @onClick={{unless @closeGuidelines (perform this.closeGuidelines) @closeGuidelines}}
            @text={{if @declineText @declineText (t "shared_phrases.guidelines.footer.decline")}}
            @variant="outline"
            class="u--float--left {{@declineQaClass}}"
            data-test-id="guidelines-decline-button"
          />
        {{/unless}}
      </modal.card-footer>
    </modal.card>
  </Shared::Modal>
  */
  {
    "id": "yTYfzpbZ",
    "block": "[[[8,[39,0],null,[[\"@close\"],[[52,[51,[30,1]],[28,[37,2],[[30,0,[\"closeGuidelines\"]]],null],[30,1]]]],[[\"default\"],[[[[1,\"\\n  \"],[8,[30,2,[\"card\"]],[[24,\"data-test-id\",\"guidelines-modal\"]],[[\"@portrait\"],[true]],[[\"default\"],[[[[1,\"\\n    \"],[8,[30,2,[\"card-header\"]],null,null,[[\"default\"],[[[[1,\"\\n      \"],[10,\"h3\"],[15,0,[29,[\"o--modalHeader__title \",[30,3]]]],[12],[1,\"\\n        \"],[1,[30,4]],[1,\"\\n      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n    \"],[8,[30,2,[\"card-body\"]],[[24,0,\"u--p__t__0\"]],null,[[\"default\"],[[[[1,\"\\n      \"],[10,2],[15,0,[30,5]],[12],[1,\"\\n        \"],[1,[28,[35,3],[[30,6]],null]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,\"hr\"],[15,0,[30,7]],[12],[13],[1,\"\\n\"],[41,[48,[30,16]],[[[1,\"        \"],[18,16,null],[1,\"\\n\"]],[]],null],[1,\"      \"],[10,0],[12],[1,\"\\n\"],[42,[28,[37,8],[[28,[37,8],[[30,8]],null]],null],null,[[[1,\"          \"],[10,0],[14,0,\"o--form__checkbox u--p__b__xs\"],[12],[1,\"\\n            \"],[10,\"label\"],[15,0,[52,[30,9,[\"qaLabel\"]],[30,9,[\"qaLabel\"]]]],[12],[1,\"\\n              \"],[8,[39,9],[[16,0,[29,[\"regram_tos \",[52,[30,9,[\"qaCheckbox\"]],[30,9,[\"qaCheckbox\"]]]]]],[16,\"data-test-id\",[30,9,[\"id\"]]]],[[\"@checked\",\"@type\"],[[30,9,[\"isChecked\"]],\"checkbox\"]],null],[1,\"\\n              \"],[1,[28,[35,3],[[28,[37,10],[[30,9,[\"label\"]]],null]],null]],[1,\"\\n\"],[41,[30,9,[\"link\"]],[[[1,\"                \"],[8,[39,11],[[4,[38,12],[\"click\",[28,[37,13],[[30,0],[30,9,[\"link\",\"onClick\"]]],null]],null]],[[\"@href\",\"@text\"],[[30,9,[\"link\",\"href\"]],[30,9,[\"link\",\"text\"]]]],null],[1,\"\\n\"]],[]],null],[1,\"            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n\"]],[9]],null],[1,\"      \"],[13],[1,\"\\n      \"],[10,2],[15,0,[30,10]],[12],[1,\"\\n        \"],[1,[28,[35,3],[[30,11]],null]],[1,\"\\n      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n    \"],[8,[30,2,[\"card-footer\"]],null,null,[[\"default\"],[[[[1,\"\\n      \"],[8,[39,14],[[16,0,[29,[[52,[30,12],\"o--btn--block\",\"u--float--right\"],\" \",[30,13]]]],[24,\"data-test-id\",\"guidelines-agree-button\"]],[[\"@isDisabled\",\"@onClick\",\"@text\"],[[28,[37,15],[[30,0,[\"canAgree\"]]],null],[30,0,[\"agree\"]],[30,0,[\"agreeButtonText\"]]]],null],[1,\"\\n\"],[41,[51,[30,12]],[[[1,\"        \"],[8,[39,14],[[16,0,[29,[\"u--float--left \",[30,14]]]],[24,\"data-test-id\",\"guidelines-decline-button\"]],[[\"@onClick\",\"@text\",\"@variant\"],[[52,[51,[30,1]],[28,[37,2],[[30,0,[\"closeGuidelines\"]]],null],[30,1]],[52,[30,15],[30,15],[28,[37,10],[\"shared_phrases.guidelines.footer.decline\"],null]],\"outline\"]],null],[1,\"\\n\"]],[]],null],[1,\"    \"]],[]]]]],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[2]]]]]],[\"@closeGuidelines\",\"modal\",\"@titleQaClass\",\"@title\",\"@subtitleQaClass\",\"@subtitle\",\"@dividerClass\",\"@checkboxList\",\"checkbox\",\"@disclaimerQaClass\",\"@disclaimer\",\"@noDeclineButton\",\"@agreeQaClass\",\"@declineQaClass\",\"@declineText\",\"&default\"],false,[\"shared/modal\",\"unless\",\"perform\",\"html-safe\",\"if\",\"has-block\",\"yield\",\"each\",\"-track-array\",\"input\",\"t\",\"shared/link\",\"on\",\"action\",\"shared/ui/button\",\"not\"]]",
    "moduleName": "shared/components/shared/guidelines.hbs",
    "isStrictMode": false
  });
  let GuidelinesComponent = _exports.default = (_class = class GuidelinesComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "intl", _descriptor2, this);
      _initializerDefineProperty(this, "dialogManager", _descriptor3, this);
      _defineProperty(this, "closeGuidelines", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          const didConfirm = yield this.dialogManager.confirmation(this.intl.t('shared_phrases.guidelines.close.title'), {
            description: this.intl.t('shared_phrases.guidelines.close.description'),
            confirmButton: this.intl.t('shared_words.leave')
          });
          if (!didConfirm) {
            return;
          }
          if (this.args.hideGuidelines) {
            this.args.hideGuidelines();
          }
          if (this.args.educationPromise) {
            this.args.educationPromise.reject();
          }
          if (this.args.onDeclinedAction) {
            this.args.onDeclinedAction(this.args.checkboxList);
          }
        }
      }), null, "closeGuidelines", null));
    }
    get agreeButtonText() {
      if (this.args.agreeText) {
        return this.args.agreeText;
      }
      return this.intl.t('shared_phrases.guidelines.footer.agree');
    }
    get currentUser() {
      return this.auth.currentUserModel;
    }
    get canAgree() {
      return this.args.checkboxList.every(checkbox => checkbox.isChecked);
    }
    willDestroy() {
      super.willDestroy();
      this.args.checkboxList.forEach(checkbox => {
        checkbox.isChecked = false;
      });
    }
    agree() {
      if (!this.canAgree) return;
      if (this.args.userAttribute) {
        this.currentUser.set(`${this.args.userAttribute}`, true);
      }
      this.currentUser.save();
      if (this.args.educationPromise) {
        this.args.educationPromise.resolve();
      }
      if (this.args.onSuccessAction) {
        this.args.onSuccessAction();
      }
      if (this.args.hideGuidelines) {
        this.args.hideGuidelines();
      }
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "dialogManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "agree", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "agree"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, GuidelinesComponent);
});